<div>
    <msc-froala [(content)]="content" (contentChange)="update()"></msc-froala>
</div>

<app-timer [timerService]="timerService" (close)="timerInit()"></app-timer>
